import { gql } from '@/shared/graphql/generated/explorer';

export const getFundingEventsQuery = gql(/* GraphQL */ `
  query getFundingEvents($idSs58s: [String!]!, $first: Int, $offset: Int) {
    events: allAccountFundingEvents(
      filter: { accountByAccountId: { idSs58: { in: $idSs58s } } }
      offset: $offset
      first: $first
      orderBy: EVENT_ID_DESC
    ) {
      edges {
        node {
          ...AccountFundingEvent
        }
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        startCursor
        hasPreviousPage
      }
    }
  }
`);
